import { useState, useEffect } from "react";
import companyLogo from "../images/Ladradoc.jpg";
import DropdownExample from "./dropdown";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function Navigator({ active }) {

    const [tipo, setTipo] = useState(null);
    const [cargando, setCargando] = useState(true);


    useEffect(() => {
        const BASE_URL = window.location.hostname === "localhost" 
            ? "http://localhost:4000" 
            : "https://vetladradoc.uy";
            
        fetch(`${BASE_URL}/api/auth/status`, {
            credentials: "include" // <-- IMPORTANTE: Incluye las cookies en la petición
        })
            .then(res => res.json())
            .then(res => {
                console.log("Respuesta del servidor:", res);
                if (res.auth === true) {
                    setTipo(res.user.Tipo)
                }
            })
            .catch(err => console.error("Error:", err))
            .finally(() => setCargando(false));
    }, []);

    if (cargando) return null;

    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand href="/">
                    <img 
                        style={{ padding: "10px" }} 
                        src={companyLogo} 
                        alt="Logo Ladradoc" 
                        height={'75px'} 
                    />
                    Veterinaria Ladradoc
                </Navbar.Brand>
                
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link 
                            href="/" 
                            active={active === "Inicio"}
                        >
                            Inicio
                        </Nav.Link>
                        
                        <Nav.Link 
                            href="/#/register" 
                            active={active === "Registrarme"}
                        >
                            Registrarme
                        </Nav.Link>
                        
                        <Nav.Link 
                            href={tipo === "a" ? "/#/agendaAdmin" : "/#/agenda"} 
                            active={active === "Agenda"}
                        >
                            Agenda
                        </Nav.Link>
                    </Nav>
                    
                    <div className="d-flex align-items-center">
                        <DropdownExample />
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigator;